import { restaurant } from "../lib/data";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1f2620] text-[#f9f6f0] pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-[#f9f6f0]/10">
          <div className="md:col-span-5">
            <p className="overline text-[#f1c98a]">The Greek Yum Yum&rsquo;s</p>
            <p className="mt-6 font-serif-display text-3xl italic leading-snug max-w-md text-[#f9f6f0]/90">
              &ldquo;Eat well, laugh loudly, stay long.&rdquo;
            </p>
            <p className="mt-4 text-sm text-[#f9f6f0]/55">
              A family-run taverna in Planos Tsilivi, Zakynthos — since 2010.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[#f1c98a]">Visit</p>
            <ul className="mt-5 space-y-2 text-sm text-[#f9f6f0]/80">
              <li>{restaurant.location}</li>
              <li>{restaurant.hoursLine}</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-[#f1c98a]">Get in touch</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li>
                <a
                  href={`tel:${restaurant.phoneRaw}`}
                  data-testid="footer-phone"
                  className="hover:text-[#d98a6c] transition-colors"
                >
                  {restaurant.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${restaurant.email}`}
                  data-testid="footer-email"
                  className="hover:text-[#d98a6c] transition-colors break-words"
                >
                  {restaurant.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${restaurant.whatsappRaw}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-[#d98a6c] transition-colors"
                >
                  WhatsApp →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-10 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <h2
            aria-hidden
            className="font-serif-display text-[16vw] md:text-[11vw] leading-[0.85] tracking-tighter text-[#f9f6f0]/90"
          >
            Yum <span className="italic text-[#d98a6c]">Yum&rsquo;s</span>
          </h2>
          <div className="text-xs tracking-[0.24em] uppercase text-[#f9f6f0]/55 md:text-right">
            <p>© {year} The Greek Yum Yum&rsquo;s</p>
            <p className="mt-1">All rights reserved · Zakynthos, Greece</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
